/* eslint-disable camelcase, no-invalid-this */
import { html } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { getItemContentAndValue } from '../../fc-form-field-helper';

const OTHER_PREFIX = 'Other: ';

/**
 * On change other value
 * @param {Event} event
 * @private
 */
const _onChangeOther = function(event) {
  const { disabled, singleSelection } = this;
  if (disabled) return;
  const { key, target: { value } } = event;
  if (key === 'Enter') {
    this.otherOptionValue = value;
    if (singleSelection) {
      this.values = [value];
    } else {
      this.addValue(value);
    }
  }
};

/**
 * Remove Other field
 * @private
 */
const _removeOtherField = function() {
  this.removeValue(this.otherOptionValue);
  this.otherOptionValue = null;
};

/**
 * Render the "Add Other" option
 * @return {*}
 * @private
 */
const _renderAddOther = function() {
  const { disabled, otherOptionValue, allowOtherOption } = this;
  if (!allowOtherOption) return;
  if (disabled && !otherOptionValue) return;
  const isSelected = !!otherOptionValue;
  return html`
    <button
        disabled-events
        ?disabled=${disabled}
        ?active="${isSelected}">
        ${otherOptionValue ?
        html`
        <div class="row">${OTHER_PREFIX}${otherOptionValue}<fc-icon icon="close" class="remove-other-field" style="--fc-icon-size: 15px;" @click="${_removeOtherField.bind(this)}"></fc-icon></div>` : html`
        <input
            class="add-other-input"
            type="text"
            @keyup="${_onChangeOther.bind(this)}"
            placeholder="Other..."/>`}
    </button>`;
};

const onChange = function({ detail: { changedButton, action } }) {
  const { singleSelection } = this;
  const { value } = changedButton;
  if (changedButton.hasAttribute('other')) {
    return;
  }
  if (singleSelection) {
    // single select
    if (action === 'ADDED') {
      this.values = [value];
    } else {
      this.values = [];
    }
  } else {
    // multi select
    if (action === 'ADDED') {
      this.addValue(value);
    } else {
      this.removeValue(value);
    }
  }
};

export const render_button_group = function() {
  const { options = [], values, disabled } = this;
  const slottedOptions = Array.from(this.querySelectorAll('option'));
  const isSlottedOptions = slottedOptions.length;
  const buttons = isSlottedOptions ? slottedOptions : options;
  return html`
    <fc-button-group @change="${onChange.bind(this)}">
      ${(buttons).map((tag, index) => {
    const { itemValue, itemContent } = getItemContentAndValue(tag);
    const isSelected = (values || []).includes(itemValue);
    return html`<button
                tabindex="${index + 1}"
                ?disabled=${disabled}
                ?active="${isSelected}"
                value="${itemValue}">
                    <div class="row">${unsafeHTML(itemContent)}</div>
                </button>`;
  })}
    ${_renderAddOther.call(this)}
    </fc-button-group>
    `;
};
